<template>
  <div id="email">
    <b-form-input
      v-model="email"
      type="email"
      required
      ref="input"
      placeholder="helene@teddi.co"
      :class="{ 'border-bottom-blue text-blue': isEmailSet }"
      class="mb-0 pl-0 ml-0 box-shadow-none"
      @update="checkEmailAvailability"
      debounce="1000"
      :autofocus="this.$router.currentRoute.name != 'dashboard'"
    ></b-form-input>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isEmailSet"]),
    email: {
      get() {
        return this.$store.state.userData.email;
      },
      set(value) {
        if (value != null && value != "" && this.reg.test(value)) {
          this.$store.commit("SET_EMAIL", value);
        } else {
          this.$store.commit("SET_EMAIL", null);
        }
      },
    },
  },
  data() {
    return {
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  methods: {
    checkEmailAvailability() {
      if (this.$router.currentRoute.name == "register" && this.$store.state.userData.email)
        this.$store.dispatch("checkEmailAvailability");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";
@import "@/styles/forms.scss";

input {
  @include media-breakpoint-up(md) {
    width: 18rem;
  }
  margin-left: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
}
</style>
